const CART_TOKEN_STORAGE_KEY = 'avada-chatty/cart-token';

export function getCartTokenStore() {
  // SSR-safe: nếu chưa có window thì trả về store rỗng
  if (typeof window === 'undefined') {
    return {
      set: () => {},
      get: () => undefined,
      subscribe: () => () => {}
    };
  }

  if (window.__chattyCartStore) return window.__chattyCartStore;

  const subs = new Set();

  window.__chattyCartStore = {
    set: function(token) {
      localStorage.setItem(CART_TOKEN_STORAGE_KEY, token);
      subs.forEach(function(fn) {
        try {
          fn(token);
        } catch (_) {}
      });
    },
    get: function() {
      return localStorage.getItem(CART_TOKEN_STORAGE_KEY);
    },
    subscribe: function(fn, opts) {
      if (!opts) opts = {replay: true};
      subs.add(fn);
      const value = localStorage.getItem(CART_TOKEN_STORAGE_KEY);
      if (opts.replay && value != null) fn(value);
      return function unsubscribe() {
        subs.delete(fn);
      };
    }
  };

  return window.__chattyCartStore;
}

export function setCartToken(id) {
  getCartTokenStore().set(id);
}
